// Shared between the browser class (packages/frontend/TrafficJourney.ts) and
// the backend service — no Node-only imports here, so this file is safe to
// bundle into the browser as well.

export const TRAFFIC_JOURNEY_EVENT_TYPES = ['journey_start', 'cross_site', 'outbound'] as const;

export type TrafficJourneyEventType = (typeof TRAFFIC_JOURNEY_EVENT_TYPES)[number];

/** What the browser actually sends. `site` and a timestamp are deliberately
 * absent — the server assigns both itself (see TrafficJourneyService) rather
 * than trusting client-supplied values. */
export interface TrafficJourneyEventPayload {
    journeyId: string;
    type: TrafficJourneyEventType;
    path?: string;
    target?: string;
    referrer?: string;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isValidUuid(value: unknown): value is string {
    return typeof value === 'string' && UUID_PATTERN.test(value);
}

export function isValidTrafficJourneyEventType(value: unknown): value is TrafficJourneyEventType {
    return typeof value === 'string' && (TRAFFIC_JOURNEY_EVENT_TYPES as readonly string[]).includes(value);
}
